import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private translateService: TranslateService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      if (err.status === 410 && request.url.includes('/api/driversign/')) {
        return throwError(() => err);
      }

      if (err.status === 401) {
        // this.auth.logoutProv();
      }
      let error = null;
      if (err.status == 404 || err.status == 400) {
        error = err.error.title;
      } else {
        error = this.translateService.instant('error.request');
      }

      return throwError(error);
    })) as Observable<HttpEvent<unknown>>;
  }
}